import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.codespirit.in/api',
  withCredentials: true, // send cookies
});

export async function login(identifier: string, password: string) {
  const res = await api.post('/auth/login', { identifier, password });
  return res.data;
}

export async function getCurrentUser() {
  const res = await api.get('/auth/me');
  return res.data;
}

export async function getAllHackathons(filters?: {
  search?: string;
  status?: string;
  country?: string;
  state?: string;
  registrationFees?: string;
  location?: string;
  organization?: string;
  dateRange?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', '50');

  if (filters?.search) params.append('search', filters.search);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.country) params.append('country', filters.country);
  if (filters?.state) params.append('state', filters.state);
  if (filters?.registrationFees) params.append('registrationFees', filters.registrationFees);
  if (filters?.location) params.append('location', filters.location);
  if (filters?.organization) params.append('organization', filters.organization);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);

  const res = await api.get(`/hackathons?${params.toString()}`);
  console.log('API Response:', res.data);
  return res.data;
}

export async function getAllQuizzes(filters?: {
  search?: string;
  category?: string;
  organizer?: string;
  pricing?: string;
  status?: string;
  dateRange?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', '50');

  if (filters?.search) params.append('search', filters.search);
  if (filters?.category) params.append('category', filters.category);
  if (filters?.organizer) params.append('organizer', filters.organizer);
  if (filters?.pricing) params.append('pricing', filters.pricing);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);

  const res = await api.get(`/quizzes?${params.toString()}`);
  return res.data;
}

export async function getAllQuizzesAdmin(filters?: {
  search?: string;
  category?: string;
  organizer?: string;
  pricing?: string;
  status?: string;
  country?: string;
  state?: string;
  dateRange?: string;
  startDate?: string;
  endDate?: string;
  registrationStartDate?: string;
  registrationEndDate?: string;
  featured?: string;
  verified?: string;
  active?: string;
  showExpired?: boolean;
  createdDateFilter?: string;
  page?: string;
  limit?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', filters?.limit || '50');
  if (filters?.search) params.append('search', filters.search);
  if (filters?.category) params.append('category', filters.category);
  if (filters?.organizer) params.append('organizer', filters.organizer);
  if (filters?.pricing) params.append('pricing', filters.pricing);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.country) params.append('country', filters.country);
  if (filters?.state) params.append('state', filters.state);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);
  if (filters?.registrationStartDate) params.append('registrationStartDate', filters.registrationStartDate);
  if (filters?.registrationEndDate) params.append('registrationEndDate', filters.registrationEndDate);
  if (filters?.featured) params.append('featured', filters.featured);
  if (filters?.verified) params.append('verified', filters.verified);
  if (filters?.active) params.append('active', filters.active);
  if (filters?.showExpired !== undefined) params.append('showExpired', filters.showExpired.toString());
  if (filters?.createdDateFilter) params.append('createdDateFilter', filters.createdDateFilter);
  if (filters?.page) params.append('page', filters.page);
  const res = await api.get(`/quizzes/admin?${params.toString()}`);
  return res.data;
}

export async function getAllEvents(filters?: {
  search?: string;
  eventType?: string;
  category?: string;
  organization?: string;
  pricing?: string;
  status?: string;
  country?: string;
  state?: string;
  location?: string;
  dateRange?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', '50');

  if (filters?.search) params.append('search', filters.search);
  if (filters?.eventType) params.append('eventType', filters.eventType);
  if (filters?.category) params.append('category', filters.category);
  if (filters?.organization) params.append('organization', filters.organization);
  if (filters?.pricing) params.append('pricing', filters.pricing);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.country) params.append('country', filters.country);
  if (filters?.state) params.append('state', filters.state);
  if (filters?.location) params.append('location', filters.location);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);

  const res = await api.get(`/events?${params.toString()}`);
  return res.data;
}

export async function getAllEventsAdmin(filters?: {
  search?: string;
  eventType?: string;
  category?: string;
  organization?: string;
  pricing?: string;
  status?: string;
  country?: string;
  state?: string;
  location?: string;
  dateRange?: string;
  startDate?: string;
  endDate?: string;
  registrationStartDate?: string;
  registrationEndDate?: string;
  featured?: string;
  verified?: string;
  active?: string;
  showExpired?: boolean;
  createdDateFilter?: string;
  page?: string;
  limit?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', filters?.limit || '50');
  if (filters?.search) params.append('search', filters.search);
  if (filters?.eventType) params.append('eventType', filters.eventType);
  if (filters?.category) params.append('category', filters.category);
  if (filters?.organization) params.append('organization', filters.organization);
  if (filters?.pricing) params.append('pricing', filters.pricing);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.country) params.append('country', filters.country);
  if (filters?.state) params.append('state', filters.state);
  if (filters?.location) params.append('location', filters.location);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);
  if (filters?.registrationStartDate) params.append('registrationStartDate', filters.registrationStartDate);
  if (filters?.registrationEndDate) params.append('registrationEndDate', filters.registrationEndDate);
  if (filters?.featured) params.append('featured', filters.featured);
  if (filters?.verified) params.append('verified', filters.verified);
  if (filters?.active) params.append('active', filters.active);
  if (filters?.showExpired !== undefined) params.append('showExpired', filters.showExpired.toString());
  if (filters?.createdDateFilter) params.append('createdDateFilter', filters.createdDateFilter);
  if (filters?.page) params.append('page', filters.page);
  const res = await api.get(`/events/admin?${params.toString()}`);
  return res.data;
}

export async function getAllHackathonsAdmin(filters?: {
  search?: string;
  status?: string;
  country?: string;
  state?: string;
  registrationFees?: string;
  location?: string;
  organization?: string;
  category?: string;
  dateRange?: string;
  startDate?: string;
  endDate?: string;
  registrationStartDate?: string;
  registrationEndDate?: string;
  featured?: string;
  verified?: string;
  active?: string;
  showExpired?: boolean;
  createdDateFilter?: string;
  page?: string;
  limit?: string;
}) {
  const params = new URLSearchParams();
  params.append('limit', filters?.limit || '50');
  if (filters?.search) params.append('search', filters.search);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.country) params.append('country', filters.country);
  if (filters?.state) params.append('state', filters.state);
  if (filters?.registrationFees) params.append('registrationFees', filters.registrationFees);
  if (filters?.location) params.append('location', filters.location);
  if (filters?.organization) params.append('organization', filters.organization);
  if (filters?.category) params.append('category', filters.category);
  if (filters?.dateRange) params.append('dateRange', filters.dateRange);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);
  if (filters?.registrationStartDate) params.append('registrationStartDate', filters.registrationStartDate);
  if (filters?.registrationEndDate) params.append('registrationEndDate', filters.registrationEndDate);
  if (filters?.featured) params.append('featured', filters.featured);
  if (filters?.verified) params.append('verified', filters.verified);
  if (filters?.active) params.append('active', filters.active);
  if (filters?.showExpired !== undefined) params.append('showExpired', filters.showExpired.toString());
  if (filters?.createdDateFilter) params.append('createdDateFilter', filters.createdDateFilter);
  if (filters?.page) params.append('page', filters.page);
  const res = await api.get(`/hackathons/admin?${params.toString()}`);
  return res.data;
}

// Placeholder for sending notification
export async function sendHackathonNotification(payload: { hackathonId: string; message: string }) {
  // TODO: Update endpoint to match backend
  const res = await api.post('/notifications/hackathon', payload);
  return res.data;
}

export async function sendGeneralNotification(payload: {
  title: string;
  body: string;
  image?: string;
  data?: any;
  deliveryMode?: 'fcm' | 'in_app' | 'both';
}) {
  const res = await api.post('/users/notify/broadcast', payload);
  return res.data;
}
// Add these to your API service file
export async function getPaymentWithdrawalRequests(filters?: any) {
  const res = await api.get('/hackathons/:username/payment-withdrawal-status', { params: filters });
  return res.data;
}

export async function updatePaymentWithdrawalRequest(requestId: string, updateData: any) {
  const res = await api.put(`/hackathons/:username/payment-withdrawal-status/${requestId}`, updateData);
  return res.data;
}
// Automated notification scheduler APIs
export async function getSchedulerStatus() {
  const res = await api.get('/notifications/scheduler/status');
  return res.data;
}

export async function triggerRegistrationReminders() {
  const res = await api.post('/notifications/scheduler/trigger/registration');
  return res.data;
}

export async function triggerStartNotifications() {
  const res = await api.post('/notifications/scheduler/trigger/start');
  return res.data;
}

export async function getUpcomingNotifications() {
  const res = await api.get('/notifications/upcoming');
  return res.data;
}

export async function getNotificationStats() {
  const res = await api.get('/notifications/stats');
  return res.data;
}

// Admin Hackathon Management APIs
export async function getHackathonDetails(id: string) {
  const res = await api.get(`/admin/hackathons/${id}`);
  return res.data;
}

export async function updateHackathon(id: string, data: {
  status?: string;
  featured?: boolean;
  takeRegistrations?: boolean;
}) {
  const res = await api.put(`/admin/hackathons/${id}`, data);
  return res.data;
}

export async function deleteHackathon(id: string) {
  const res = await api.delete(`/admin/hackathons/${id}`);
  return res.data;
}

export async function getHackathonAnalytics(id: string) {
  const res = await api.get(`/admin/hackathons/${id}/analytics`);
  return res.data;
}

export async function getHackathonParticipants(id: string) {
  const res = await api.get(`/admin/hackathons/${id}/participants`);
  return res.data;
}

// Get user analytics statistics
export async function getUserAnalyticsStats() {
  const res = await api.get('/users/analytics/stats');
  return res.data;
}

// Get all users with filtering and pagination
export async function getAllUsersAdmin(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      params.append(key, value.toString());
    }
  });

  const res = await api.get(`/users/analytics/all?${params}`);
  return res.data;
}

// Get single user details
export async function getUserDetails(id: string) {
  const res = await api.get(`/users/analytics/${id}`);
  return res.data;
}

// Delete user (requires confirmation)
export async function deleteUser(id: string) {
  const res = await api.delete(`/users/analytics/${id}`, {
    data: { confirmation: 'DELETE_USER_CONFIRMED' }
  });
  return res.data;
}

// Get new users per day in date range
export async function getNewUsersAnalytics(startDate: string, endDate: string) {
  const res = await api.get(`/users/analytics/new-users?startDate=${startDate}&endDate=${endDate}`);
  return res.data;
}


// Add Admin Sponsor to Quiz
export async function addQuizAdminSponsor(quizId: string, sponsorData: {
  name: string;
  website?: string;
  imageUrl?: string;
}) {
  try {
    console.log('Adding sponsor to quiz:', quizId, sponsorData);
    const res = await api.post(`/quizzes/${quizId}/admin-sponsors`, sponsorData);
    console.log('Add sponsor response:', res.data);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Add Quiz Admin Sponsor:', error.response?.data || error);
    throw error;
  }
}

// Get Admin Sponsors for Quiz
export async function getQuizAdminSponsors(quizId: string) {
  try {
    console.log('Fetching sponsors for quiz:', quizId);
    const res = await api.get(`/quizzes/${quizId}/admin-sponsors`);
    console.log('Get sponsors response:', res.data);
    // Transform backend response to match expected format
    return {
      success: res.data.success,
      data: res.data.sponsors || []
    };
  } catch (error: any) {
    console.error('API Error - Get Quiz Admin Sponsors:', error.response?.data || error);
    // Return empty success response for non-critical failure
    if (error.response?.status === 404) {
      console.log('Quiz not found, returning empty sponsors');
      return { success: true, data: [] };
    }
    throw error;
  }
}

// Update Admin Sponsor for Quiz
export async function updateQuizAdminSponsor(quizId: string, sponsorId: string, sponsorData: {
  name?: string;
  website?: string;
  imageUrl?: string;
}) {
  try {
    console.log('Updating sponsor:', sponsorId, 'for quiz:', quizId, sponsorData);
    const res = await api.put(`/quizzes/${quizId}/admin-sponsors/${sponsorId}`, sponsorData);
    console.log('Update sponsor response:', res.data);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Update Quiz Admin Sponsor:', error.response?.data || error);
    throw error;
  }
}

// Delete Admin Sponsor from Quiz
export async function deleteQuizAdminSponsor(quizId: string, sponsorId: string) {
  try {
    console.log('Deleting sponsor:', sponsorId, 'from quiz:', quizId);
    const res = await api.delete(`/quizzes/${quizId}/admin-sponsors/${sponsorId}`);
    console.log('Delete sponsor response:', res.data);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Delete Quiz Admin Sponsor:', error.response?.data || error);
    throw error;
  }
}


// Event Admin Sponsor Management API Functions

// Add Admin Sponsor to Event
export async function addEventAdminSponsor(eventId: string, sponsorData: {
  name: string;
  website?: string;
  imageUrl?: string;
}) {
  try {
    const res = await api.post(`/events/${eventId}/admin-sponsors`, sponsorData);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Add Event Admin Sponsor:', error);
    throw error;
  }
}

// Get Admin Sponsors for Event
export async function getEventAdminSponsors(eventId: string) {
  try {
    const res = await api.get(`/events/${eventId}/admin-sponsors`);
    // Transform backend response to match expected format
    return {
      success: res.data.success,
      data: res.data.sponsors || []
    };
  } catch (error: any) {
    console.error('API Error - Get Event Admin Sponsors:', error);
    // Return empty success response for non-critical failure
    if (error.response?.status === 404) {
      return { success: true, data: [] };
    }
    throw error;
  }
}

// Update Admin Sponsor for Event
export async function updateEventAdminSponsor(eventId: string, sponsorId: string, sponsorData: {
  name?: string;
  website?: string;
  imageUrl?: string;
}) {
  try {
    const res = await api.put(`/events/${eventId}/admin-sponsors/${sponsorId}`, sponsorData);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Update Event Admin Sponsor:', error);
    throw error;
  }
}

// Delete Admin Sponsor from Event
export async function deleteEventAdminSponsor(eventId: string, sponsorId: string) {
  try {
    const res = await api.delete(`/events/${eventId}/admin-sponsors/${sponsorId}`);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Delete Event Admin Sponsor:', error);
    throw error;
  }
}

// Admin Sponsor Management API Functions
export async function addAdminSponsor(hackathonId: string, sponsorData: any) {
  try {
    const res = await api.post(`/hackathons/${hackathonId}/admin-sponsors`, sponsorData);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Add Admin Sponsor:', error);
    throw error;
  }
}

export async function getAdminSponsors(hackathonId: string) {
  try {
    const res = await api.get(`/hackathons/${hackathonId}/admin-sponsors`);
    // Transform backend response to match expected format
    return {
      success: res.data.success,
      data: res.data.sponsors || []
    };
  } catch (error: any) {
    console.error('API Error - Get Admin Sponsors:', error);
    // Return empty success response for non-critical failure
    if (error.response?.status === 404) {
      return { success: true, data: [] };
    }
    throw error;
  }
}

export async function updateAdminSponsor(hackathonId: string, sponsorId: string, sponsorData: any) {
  try {
    const res = await api.put(`/hackathons/${hackathonId}/admin-sponsors/${sponsorId}`, sponsorData);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Update Admin Sponsor:', error);
    throw error;
  }
}

export async function deleteAdminSponsor(hackathonId: string, sponsorId: string) {
  try {
    const res = await api.delete(`/hackathons/${hackathonId}/admin-sponsors/${sponsorId}`);
    return res.data;
  } catch (error: any) {
    console.error('API Error - Delete Admin Sponsor:', error);
    throw error;
  }
}


// Sponsor interfaces
export interface GeneralSponsor {
  _id: string;
  name: string;
  websiteUrl: string;
  imageUrl: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  formattedCreatedAt: string;
  displayWebsiteUrl: string;
}

export interface GeneralSponsorFormData {
  name: string;
  websiteUrl: string;
  imageUrl: string;
  isActive: boolean;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  count?: number;
}

// Sponsor API functions
export async function getAllGeneralSponsors(activeOnly?: boolean): Promise<ApiResponse<GeneralSponsor[]>> {
  try {
    const params = activeOnly ? { active: 'true' } : {};
    const response = await api.get('/sponsors', { params });
    return response.data;
  } catch (error: any) {
    console.error('API Error - Get All Sponsors:', error.response?.data || error);
    throw error;
  }
}

export async function getGeneralSponsor(id: string): Promise<ApiResponse<GeneralSponsor>> {
  try {
    const response = await api.get(`/sponsors/${id}`);
    return response.data;
  } catch (error: any) {
    console.error('API Error - Get Sponsor:', error.response?.data || error);
    throw error;
  }
}

export async function createGeneralSponsor(sponsorData: GeneralSponsorFormData): Promise<ApiResponse<GeneralSponsor>> {
  try {
    const response = await api.post('/sponsors', sponsorData);
    return response.data;
  } catch (error: any) {
    console.error('API Error - Create Sponsor:', error.response?.data || error);
    throw error;
  }
}

export async function updateGeneralSponsor(
  id: string,
  sponsorData: Partial<GeneralSponsorFormData>
): Promise<ApiResponse<GeneralSponsor>> {
  try {
    const response = await api.put(`/sponsors/${id}`, sponsorData);
    return response.data;
  } catch (error: any) {
    console.error('API Error - Update Sponsor:', error.response?.data || error);
    throw error;
  }
}

export async function deleteGeneralSponsor(id: string): Promise<ApiResponse<null>> {
  try {
    const response = await api.delete(`/sponsors/${id}`);
    return response.data;
  } catch (error: any) {
    console.error('API Error - Delete Sponsor:', error.response?.data || error);
    throw error;
  }
}

export async function toggleGeneralSponsorStatus(id: string): Promise<ApiResponse<GeneralSponsor>> {
  try {
    const response = await api.patch(`/sponsors/${id}/toggle-status`);
    return response.data;
  } catch (error: any) {
    console.error('API Error - Toggle Sponsor Status:', error.response?.data || error);
    throw error;
  }
}


// Event Admin API Functions
export async function getEventDetails(id: string) {
  const res = await api.get(`/admin/events/${id}`);
  return res.data;
}

export async function updateEvent(id: string, data: {
  status?: string;
  featured?: boolean;
  takeRegistrations?: boolean;
}) {
  const res = await api.put(`/admin/events/${id}`, data);
  return res.data;
}

export async function deleteEvent(id: string) {
  const res = await api.delete(`/admin/events/${id}`);
  return res.data;
}

export async function getEventAnalytics(id: string) {
  const res = await api.get(`/admin/events/${id}/analytics`);
  return res.data;
}

export async function getEventParticipants(id: string) {
  const res = await api.get(`/admin/events/${id}/participants`);
  return res.data;
}

// Quiz Admin API Functions
export async function getQuizDetails(id: string) {
  const res = await api.get(`/admin/quizzes/${id}`);
  return res.data;
}

export async function updateQuiz(id: string, data: {
  status?: string;
  featured?: boolean;
}) {
  const res = await api.put(`/admin/quizzes/${id}`, data);
  return res.data;
}

export async function deleteQuiz(id: string) {
  const res = await api.delete(`/admin/quizzes/${id}`);
  return res.data;
}

export async function getQuizAnalytics(id: string) {
  const res = await api.get(`/admin/quizzes/${id}/analytics`);
  return res.data;
}

export async function getQuizParticipants(id: string) {
  const res = await api.get(`/admin/quizzes/${id}/participants`);
  return res.data;
}

// ─── Referral & Campus Lead Admin API ─────────────────────────────────────────
export async function getCampusLeadApps(status = 'all', page = 1) {
  const res = await api.get(`/referral/admin/applications?status=${status}&page=${page}&limit=50`);
  return res.data;
}

export async function updateCampusLeadStatus(id: string, status: string, adminNotes: string = '') {
  const res = await api.patch(`/referral/admin/applications/${id}`, { status, adminNotes });
  return res.data;
}

export async function getSwagClaims() {
  const res = await api.get(`/referral/admin/swag-claims`);
  return res.data;
}

export async function updateSwagClaimStatus(userId: string, claimId: string, status: string, notes: string = '') {
  const res = await api.patch(`/referral/admin/swag-claims/${userId}/${claimId}`, { status, notes });
  return res.data;
}

export async function getReferralLeaderboard() {
  const res = await api.get(`/referral/admin/leaderboard`);
  return res.data;
}

// Jobs Admin APIs
export async function getAllJobsAdmin(filters?: any) {
  const res = await api.get('/jobs', { params: { ...filters, limit: 100 } });
  return res.data;
}

export async function createJobAdmin(data: any) {
  const res = await api.post('/jobs', data);
  return res.data;
}

export async function updateJobAdmin(id: string, data: any) {
  const res = await api.put(`/jobs/${id}`, data);
  return res.data;
}

export async function deleteJobAdmin(id: string) {
  const res = await api.delete(`/jobs/${id}`);
  return res.data;
}

export default api; 
